import { render, staticRenderFns } from "./CChartPurchasesPerProvider.vue?vue&type=template&id=f4220e1c"
import script from "./CChartPurchasesPerProvider.vue?vue&type=script&lang=js"
export * from "./CChartPurchasesPerProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports